import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Key, FileText, Building2, Briefcase, FileSignature, ArrowRight } from 'lucide-react';
const INTENTS = [{
  title: 'Buying property',
  description: 'Contract review, title and risk checks, negotiations and settlement.',
  icon: Home,
  cta: 'Help me buy',
  href: '/buying-property'
}, {
  title: 'Selling property',
  description: 'Contract of sale, disclosure preparation, buyer enquiries and settlement.',
  icon: Key,
  cta: 'Help me sell',
  href: '/selling-property'
}, {
  title: 'Reviewing a contract',
  description: 'Understand special conditions, disclosures and key risks before you sign.',
  icon: FileText,
  cta: 'Review my contract',
  href: '/contract-review'
}, {
  title: 'SMSF or trust purchase',
  description: 'Property transactions involving SMSFs, family trusts and unit trusts.',
  icon: Building2,
  cta: 'Help with my structure',
  href: '/smsf-trust-property'
}, {
  title: 'Commercial property',
  description: 'Legal support for commercial purchases, sales and leasing matters.',
  icon: Briefcase,
  cta: 'Commercial help',
  href: '/commercial-property'
}, {
  title: 'Transfer, subdivision or certificate',
  description: 'Property transfers, subdivisions and solicitor certificates.',
  icon: FileSignature,
  cta: 'Other property matters',
  href: '/property-transfers'
}];
export function IntentSelector() {
  return <section className="py-10 md:py-14 px-5 md:px-6 bg-background" data-id="element-283" data-mp="3hzh8zdjiz2q9">
      <div className="max-w-7xl mx-auto" data-id="element-284" data-mp="3vq2sn4gszgp7">
        <div className="max-w-2xl mb-6 md:mb-8" data-id="element-285" data-mp="3vqvt5np659yw">
          <p className="eyebrow text-brand-blue mb-1" data-id="element-286" data-mp="3qx9qmocpymgt">
            where do we start?
          </p>
          <h2 className="text-3xl md:text-[2.6rem] leading-tight text-ink" data-id="element-287" data-mp="337ouf3rk1spl">
            What do you need help with?
          </h2>
          <p className="mt-4 text-muted-ink text-lg" data-id="element-288" data-mp="2z6wl6aionntb">
            Tell us the situation and we will point you to the right pathway, or
            just upload the contract and let the team take it from there.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-289" data-mp="1bwlom0ni6fi9">
          {INTENTS.map(intent => {
          const Icon = intent.icon;
          return <Link key={intent.title} to={intent.href} className="group relative flex flex-col rounded-2xl border border-border bg-surface p-7 transition-colors duration-200 hover:border-brand-blue/40" data-id="element-290" data-mp="1gx9dogs68m9u">
                <div className="mb-6 inline-flex w-12 h-12 items-center justify-center rounded-xl bg-accent-soft text-accent transition-colors group-hover:bg-brand-blue-light group-hover:text-brand-blue" data-id="element-291" data-mp="t49bqjz83vtv">
                  <Icon className="w-5 h-5" strokeWidth={2} data-id="element-292" data-mp="24khkx495u5ei" />
                </div>
                <h3 className="font-serif text-2xl text-ink mb-2" data-id="element-293" data-mp="29ircz5zl8pvw">
                  {intent.title}
                </h3>
                <p className="text-muted-ink leading-relaxed mb-7" data-id="element-294" data-mp="3u1bm4m64on3a">
                  {intent.description}
                </p>
                <span className="mt-auto inline-flex items-center gap-2 text-sm font-semibold text-accent" data-id="element-295" data-mp="3kcbnx4zg9vq5">
                  {intent.cta}
                  <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" data-id="element-296" data-mp="3fc75vaiw8sxt" />
                </span>
              </Link>;
        })}
        </div>
      </div>
    </section>;
}